export const translations = {
    'PTBR': {
        title: 'Desbloqueie seu potencial máximo',
        advantages: {
            smartSessions: 'Sessões inteligentes e ilimitadas',
            flashcards: 'Flashcards inteligentes ilimitados',
            personalizedQuizzes: 'Quizzes personalizados ilimitados',
            fastProgress: 'Progresso acelerado até 10x mais rápido',
            limitlessStudy: 'Estude sem limites. Evolua de forma real.',
        },
        pricing: 'R$80/mês – Cancele quando quiser',
        cta: 'Assinar Agora e Desbloquear Tudo',
    },
    'EN': {
        title: 'Unlock Your Full Potential',
        advantages: {
            smartSessions: 'Unlimited Smart Sessions',
            flashcards: 'Unlimited Smart Flashcards',
            personalizedQuizzes: 'Unlimited Personalized Quizzes',
            fastProgress: 'Accelerated Progress, up to 10x faster',
            limitlessStudy: 'Study without limits. Evolve for real.',
        },
        pricing: '$15/month – Cancel anytime',
        cta: 'Subscribe Now and Unlock Everything',
    },
    'ES': {
        title: 'Desbloquea tu Potencial Completo',
        advantages: {
            smartSessions: 'Sesiones Inteligentes Ilimitadas',
            flashcards: 'Tarjetas Inteligentes Ilimitadas',
            personalizedQuizzes: 'Cuestionarios Personalizados Ilimitados',
            fastProgress: 'Progreso Acelerado, hasta 10x más rápido',
            limitlessStudy: 'Estudia sin límites. Evoluciona de verdad.',
        },
        pricing: '$15/mes – Cancela en cualquier momento',
        cta: 'Suscríbete Ahora y Desbloquea Todo',
    },
    'FR': {
        title: 'Débloquez Votre Plein Potentiel',
        advantages: {
            smartSessions: 'Séances Intelligentes Illimitées',
            flashcards: 'Cartes Flash Intelligentes Illimitées',
            personalizedQuizzes: 'Quiz Personnalisés Illimités',
            fastProgress: 'Progrès Accéléré, jusqu’à 10x plus rapide',
            limitlessStudy: 'Étudiez sans limites. Évoluez pour de vrai.',
        },
        pricing: '15€/mois – Annulez à tout moment',
        cta: 'Abonnez-vous Maintenant et Débloquez Tout',
    },
    'DE': {
        title: 'Entfessle Dein volles Potenzial',
        advantages: {
            smartSessions: 'Unbegrenzte Intelligente Sitzungen',
            flashcards: 'Unbegrenzte Intelligente Karteikarten',
            personalizedQuizzes: 'Unbegrenzte Personalisierte Quizze',
            fastProgress: 'Beschleunigter Fortschritt, bis zu 10x schneller',
            limitlessStudy: 'Lerne ohne Grenzen. Entwickle dich wirklich weiter.',
        },
        pricing: '15€/Monat – Jederzeit kündbar',
        cta: 'Jetzt abonnieren und alles freischalten',
    },
    'IT': {
        title: 'Sblocca il Tuo Potenziale Completo',
        advantages: {
            smartSessions: 'Sessioni Intelligenti Illimitate',
            flashcards: 'Flashcard Intelligenti Illimitate',
            personalizedQuizzes: 'Quiz Personalizzati Illimitati',
            fastProgress: 'Progresso Accelerato, fino a 10x più veloce',
            limitlessStudy: 'Studia senza limiti. Evolvi davvero.',
        },
        pricing: '15€/mese – Annulla in qualsiasi momento',
        cta: 'Iscriviti Ora e Sblocca Tutto',
    }
}

export type LanguageKeys = keyof typeof translations;